const compareSites = {
	el: {
		buttonCompare: document.querySelector('.js-add-compare'),
		selects: document.querySelectorAll('.js-skeleton-select')
	},

	fxSetActiveComparedSite(element) {
		element.closest('.hero-small__inner-column').classList.add('skeleton-active')
	},

	fxCreateCookie(name, value, days) {
		let expires

		if (days) {
			const date = new Date()
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
			expires = `expires=${date.toUTCString()}`
		}

		document.cookie = `${name}=${value || ''}; ${expires}; path=/`
	},

	fxReadCookie(name) {
		let cookie = {}

		for (const cookies of document.cookie.split(';')) {
			let [key, value] = cookies.split('=')
			cookie[key.trim()] = value
		}

		return cookie[name]
	},

	fxSetCookies(element) {
		const id = element === this.el.buttonCompare ? element.dataset.id : element.value,
			idByUnitLeft = element.name === 'firstUnit' ? id : this.fxReadCookie('compareLeft'),
			idByUnitRight = element.name === 'firstUnit' ? this.fxReadCookie('compareRight') : id

		// O items
		if (!this.fxReadCookie('compareLeft') && !this.fxReadCookie('compareRight'))
			this.fxCreateCookie('compareLeft', id, 0)

		// 1 item 
		else if (this.fxReadCookie('compareLeft') && !this.fxReadCookie('compareRight'))
			this.fxCreateCookie('compareRight', id, 0)

		// 2 items
		else if (this.fxReadCookie('compareLeft') && this.fxReadCookie('compareRight')) {

			if (element === this.el.buttonCompare) {
				this.fxCreateCookie('compareLeft', this.fxReadCookie('compareRight'), 0)
				this.fxCreateCookie('compareRight', id, 0)
			}

			else {
				this.fxCreateCookie('compareLeft', idByUnitLeft, 0)
				this.fxCreateCookie('compareRight', idByUnitRight, 0)
			}
		}

		element === this.el.buttonCompare ? location.href = element.dataset.url : location.reload()
	},

	events() {

		for (const select of this.el.selects) {
			select.addEventListener('change', e => {
				this.fxSetActiveComparedSite(e.currentTarget)
				this.fxSetCookies(e.currentTarget)
			})
		}

		this.el.buttonCompare && this.el.buttonCompare.addEventListener('click', e => this.fxSetCookies(e.currentTarget))

	},

	init() {
		this.events()
	}

}

compareSites.init()